import { render, staticRenderFns } from "./voice-talk.vue?vue&type=template&id=870b3f54&scoped=true&"
import script from "./voice-talk.vue?vue&type=script&lang=js&"
export * from "./voice-talk.vue?vue&type=script&lang=js&"
import style0 from "./voice-talk.vue?vue&type=style&index=0&id=870b3f54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870b3f54",
  null
  
)

export default component.exports